import { ListItem } from "@mui/material";
import { BeautifulMentionsMenuItemProps } from "lexical-beautiful-mentions";
import { omit } from "lodash";
import { forwardRef } from "react";

export const LexicalMentionsMenuItem = forwardRef<HTMLLIElement, BeautifulMentionsMenuItemProps>(
  ({ selected, ...props }, ref) => {
    return (
      <ListItem
        ref={ref}
        sx={{
          backgroundColor: selected ? "#ffffff" : "#hhh",
          cursor: selected ? "pointer" : "auto",
          marginBottom: "2px",
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
          height: "100%",
        }}
        {...omit(props, ["label", "itemValue"])}
      />
    );
  }
);
